"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteSections = AutocompleteSections;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("./utils");
const react_1 = require("react");
const SectionRow_1 = require("./SectionRow");
function getEndpoint(searchTerm) {
    return `/admin/autocomplete/sections?term=${searchTerm}`;
}
function AutocompleteSections({ searchTerm }) {
    const { data } = (0, utils_1.useQuery)((0, react_1.useMemo)(() => getEndpoint(searchTerm), [searchTerm]), { cache: false });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [data === null || data === void 0 ? void 0 : data.map((section, i) => ((0, jsx_runtime_1.jsx)(SectionRow_1.SectionRow, { section: section, hasSubsections: !!section.has_subsections }, `as${section.id}-${i}`))), !!data && data.length === 0 && ((0, jsx_runtime_1.jsx)("div", { className: "AutocompleteWindow__not-found", children: (0, jsx_runtime_1.jsx)("strong", { children: "Sekce nenalezena" }) }))] }));
}
